export default "./images/survio-S-BQh-assets-reference-br.png";